import { createApp } from "vue";
import Carrers from "./Carrers.vue";

const app = createApp({
  components: {
    "carrers-component": Carrers,

  },
}).mount("#container-carrers");
